import { IResponseDataRefresh, IDeliveryInformation } from './types';
import { IPdpResponseData } from './pdpTypes';

interface HttpResponse {
    status: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
}
export class Fetch {
    private apiLink: string;

    private detailComponentEndpoint = 'productdetailspage/componentsdata';
    private dataRefreshEndpoint = 'flexiblesetpage/componentsdatarefresh';
    
    constructor(apiLink) {
        this.apiLink = apiLink;
        this.handleError.bind(this);
    }

    public dataRefresh(fsCode: string, masterArticleNo: number,
        salesArticleVariantKey: string, brickNo: number, brickItemNo: number,
        otherSelected:
            {
                masterArticleNo: number;
                salesArticleVariantKey: string;
                brickItemNo: number;
                brickNo: number;
                deliveryInformation: IDeliveryInformation;
                availabilityState: number
            }[]
    ): Promise<IResponseDataRefresh> {
        const urlToHost = this.apiLink;
        const apiUrl = urlToHost + this.dataRefreshEndpoint;

        const requestUrl = new URL(apiUrl);

        const dataRefreshPayload = {
            'fsCode': fsCode,
            'changed': {
                'masterArticleNo': masterArticleNo,
                'salesArticleVariantKey': salesArticleVariantKey,
                'brickNo': brickNo,
                'brickItemNo': brickItemNo
            },
            'otherSelected': otherSelected
        };

        return this.request(requestUrl.toString(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataRefreshPayload)
        }, 3500)
            .then(response => (response.status === 200 ? response.data : undefined))
            .catch(error => this.handleError(error));
    }

    // obsolete will be removed later:
    public fetch(
        salesArticleNo: string,
        colorCode: string,
        masterArticleNo: number,
        sizeCode: string,
        navigationKey?: string,
        wwsStatus?: string
    ): Promise<IPdpResponseData> {
        const urlToHost = this.apiLink;
        const apiUrl = urlToHost + this.detailComponentEndpoint;

        const requestUrl = new URL(apiUrl);
        requestUrl.searchParams.set('salesArticleNo', salesArticleNo);
        requestUrl.searchParams.set('colorCode', colorCode);
        requestUrl.searchParams.set('masterArticleNo', masterArticleNo.toString());

        if (navigationKey) requestUrl.searchParams.set('navigationKey', navigationKey);
        if (sizeCode) requestUrl.searchParams.set('sizeCode', sizeCode);
        if (wwsStatus) requestUrl.searchParams.set('availabilityStatus', wwsStatus);

        return this.request(requestUrl.toString(), {}, 3500)
            .then(response => (response.status === 200 ? response.data : undefined))
            .catch(error => this.handleError(error));
    }

    public getBasketItemCount(apiUrl: string, savKey: string): Promise<number> {
        const requestUrl = new URL(apiUrl);
        requestUrl.searchParams.set('savKeyList', savKey);

        return this.request(requestUrl.toString())
            .then(response => {
                if (response.status !== 200 || !response.data) return 1;
                //service can handle multiple but we only care about one
                const savKeyToCount = response.data;
                if (!(savKey in savKeyToCount)) return 1;
                return savKeyToCount[savKey];
            })
            .catch(error => this.handleError(error));
    }
    
    public getPriceListForSizes(apiLink: string, savKeys: string[]):
        Promise<object> {
        const apiUrl = apiLink + 'flexiblesetpage/sizesprice';
        const requestUrl = new URL(apiUrl);
        savKeys.forEach(savKey => {
            requestUrl.searchParams.append('sizeSavKeys', savKey);
        });

        return this.request(requestUrl.toString())
            .then(response => {
                if (response.status !== 200 || !response.data) return 1;
                return response.data;
            })
            .catch(error => this.handleError(error));
    }

    public getBasketFlexibleSetAmount(apiUrl: string, basketItemId: string): Promise<number> {
        const requestUrl = new URL(this.apiLink + apiUrl + basketItemId);

        return this.request(requestUrl.toString())
            .then(response => {
                if (response.status !== 200 || !response.data) return 1;
                return response.data.amount;
            })
            .catch(error => this.handleError(error));
    }

    private async request(url: string, options: RequestInit = {}, timeout?: number): Promise<HttpResponse> {
        const controller = timeout ? new AbortController() : undefined;
        const timeoutId = timeout ? window.setTimeout(() => controller?.abort(), timeout) : undefined;

        try {
            const response = await fetch(url, {
                ...options,
                credentials: 'same-origin',
                signal: controller?.signal
            });

            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`);
            }

            const body = await response.text();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let data: any;
            try {
                data = JSON.parse(body);
            } catch {
                data = body;
            }
            return { status: response.status, data };
        } finally {
            if (timeoutId !== undefined) window.clearTimeout(timeoutId);
        }
    }

    private handleError(error: Error) {
        // eslint-disable-next-line no-console
        console.warn(`ajax fetch failed with "${error.name}: ${error.message}". Full error:\n${error.stack}`);
        return 0;
    }
}
